const messages: Record<string, string> = {
	'approval.calculationPDF': 'Pobierz kalkulację PDF',
	'completeDamageImages.description':
		'Dodaj przynajmniej 2 zdjęcia uszkodzeń z różnych odległości.',
	'damageImages.optionalDamageImages': 'null',
	'feedback.headline': 'Dziękujemy za skorzystanie z aplikacji!',
	'feedback.rating': 'Jak oceniasz aplikację?',
	'imageRecognitionFeedback.isDamageVisible.title': 'Wykryto uszkodzenia pojazdu',
	'imageRecognitionFeedback.isDamageVisible.titleWarning': 'Nie wykryto uszkodzeń pojazdu',
	'imageRecognitionFeedback.isFrontLeftPerspectiveVisible.infoText':
		'Załączone zdjęcie nie obejmuje <b>ukośnej perspektywy z przodu</b> pojazdu. Upewnij się, że w pełni widoczny jest przód pojazdu i jego lewa strona.',
	'imageRecognitionFeedback.isFrontLeftPerspectiveVisible.title': 'Zdjęcie poglądowe z przodu',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.infoText':
		'Załączone zdjęcie nie obejmuje <b>ukośnej perspektywy z przodu</b> pojazdu. Upewnij się, że w pełni widoczny jest przód pojazdu i jego lewa strona.',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.title': 'Zdjęcie poglądowe z przodu',
	'imageRecognitionFeedback.isRearPerspectiveVisible.infoText':
		'Załączone zdjęcie nie obejmuje ukośnej perspektywy z tyłu pojazdu. Upewnij się, że w pełni widoczny jest tył pojazdu i jego prawa strona.',
	'imageRecognitionFeedback.isRearPerspectiveVisible.title': 'Zdjęcie poglądowe z tyłu',
	'imageRecognitionFeedback.isRearPerspectiveVisible.titleWarning': 'Zdjęcie poglądowe z tyłu',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.infoText':
		'Załączone zdjęcie nie obejmuje ukośnej perspektywy z tyłu pojazdu. Upewnij się, że w pełni widoczny jest tył pojazdu i jego prawa strona.',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.title': 'Zdjęcie poglądowe z tyłu',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.titleWarning': 'Zdjęcie poglądowe z tyłu',
	'imageRecognitionFeedback.isVinVisible.infoText': 'Upewnij się, że zdjęcie przedstawia nr VIN.',
	'imageRecognitionFeedback.isVinVisible.titleWarning': 'Zdjęcie nie przedstawia numeru VIN',
	'thanks.calculationPDF': 'Pobierz kalkulację PDF',
	'thanks.paragraph.first': 'Dziękujemy za skorzystanie z aplikacji',
	'waitForAudit.description.damageFound':
		'Dziękujemy za przesłane zdjęcia. Zidentyfikowaliśmy automatycznie uszkodzenia pojazdu. Nasz ekspert przygotuje wycenę i skontaktuje się z Tobą.',
	'waitForAudit.description.damageNotFound':
		'Dziękujemy za przesłane zdjęcia. Niestety nie udało się automatycznie wykryć uszkodzeń pojazdu. Nasz ekspert zweryfikuje zdjęcia i skontaktuje się z Tobą.',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',
};

export default messages;
